import { render, staticRenderFns } from "./JomBantuUploadSimcard.vue?vue&type=template&id=5e8b493e&"
import script from "./JomBantuUploadSimcard.vue?vue&type=script&lang=js&"
export * from "./JomBantuUploadSimcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports